export default class Permissions {
    constructor(option) {
        this._data = undefined;
        this._fieldCache = [
            {
                reqField: '2',
                resField: 'enablement'
            },
            {
                reqField: '256',
                resField: 'email'
            },
            {
                reqField: '1024',
                resField: 'TempID'
            },
            {
                reqField: '2048',
                resField: 'token',
                default: true
            },
            {
                reqField: '8192',
                resField: 'exchangeInfo',
                default: true
            },
            {
                reqField: '16384',
                resField: 'userFunctions',
                default: true
            }
        ];
        this.apiManager = option.apiManager;
    }

    async query(params = {}) {
        const validFields = [];
        const reqFields = []; // need send request
        if (params.fields) {
            // make sure fields to be string
            `${params.fields}`.split(',').forEach(f => {
                const item = this._fieldCache.find(item => item.reqField === f);
                if (item) {
                    validFields.push(f);
                    if (!item.data) {
                        reqFields.push(f);
                    }
                } else {
                    reqFields.push(f);
                }
            });
        } else {
            this._fieldCache.forEach(item => {
                if (item.default) {
                    validFields.push(item.reqField);
                    if (!item.data) {
                        reqFields.push(item.reqField);
                    }
                }
            });
        }

        if (reqFields.length > 0 || !this._data) {
            params.fields = reqFields.join(',');
            const data = await this.apiManager.queryPermission(params);
            // refill cache
            this._data = {};
            Object.keys(data).forEach(key => {
                const item = this._fieldCache.find(i => i.resField === key);
                if (item) {
                    item.data = data[key];
                } else {
                    this._data[key] = data[key];
                }
            });
        }

        const ret = Object.assign({}, this._data);
        validFields.forEach(f => {
            const item = this._fieldCache.find(i => i.reqField === f);
            ret[item.resField] = item.data;
        });
        return ret;
    }

    async refresh() {
        this._data = undefined;
        const reqFields = [];
        this._fieldCache.forEach(item => {
            if (item.default && item.data) {
                reqFields.push(item.reqField);
            }
            item.data = undefined;
        });
        if (reqFields.length === 0) {
            return undefined;
        }
        return this.query({ fields: reqFields.join(',') });
    }
}
